/**
 * @desc 修改年分计划
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.PlanYearCommonUpdateRequest,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/web/plan/year/updatePartPlan',
    data,
  });
}

export function mock(
  data: defs.PlanYearCommonUpdateRequest,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/mock/web/plan/year/updatePartPlan',
    data,
  });
}
